export let setLogin=(value)=>({type: 'setLogin', value});
export let addInBasket=(pId, price, qty)=>({type:'addInBasket', pId, price, qty});
export let addInTotal=(value)=>({type:'addInTotal',value});
export let removeFromBasket=(value)=>({type:'removeFromBasket',value});
export let clearBasket=()=>({type:'clearBasket'});